import { fetchPasswordInputValidation } from "../api"

export async function validateCurrentPassword(value: string, abortSignal: AbortSignal): Promise<string | undefined> {
    return (await fetchPasswordInputValidation(value, abortSignal)).errorMessage
}
